export default __webpack_public_path__ + "static/Nourish_the_Nation_Stroke--mobile-f97ff444ddcfe210feb1de77cbc301be.jpg";